/**
 * @file 环境相关的环境变量
 * @author aron.yao 2022-07-20
 */

import { ICE_MODES } from './modes'

// 本地开发对应DEV,构建环境对应PROD
export const NODE_ENV = {
  DEV: 'development',
  PROD: 'production'
}

export const IS_DEV = process.env.NODE_ENV === NODE_ENV.DEV
export const IS_TEST = ICE_MODE === ICE_MODES.TEST
export const IS_PROD = ICE_MODE === ICE_MODES.PROD